import styled from "styled-components";
import {useEffect, useState} from "react";

function normalize0between1(min, max, value){
  return (value - min) / (max - min);
}
function getOffsetCorrection(thumbWidthInPX, medium, value) {
  const diff = medium - parseInt(value);
  const direction = diff > 0 ? 1 : -1;
  const output = normalize0between1(0, medium, Math.abs(diff)) * thumbWidthInPX / 2 * direction;
  return `${isNaN(output) ? 0 : output}px`;
}

function getThumbOffsetCorrection(min, max, thumbDiameter, values) {
  const medium = (max - min) / 2;
  return {
    start: getOffsetCorrection(thumbDiameter, medium, values[0]),
    end: getOffsetCorrection(thumbDiameter, medium, values[1])
  }
}

export const IntInputRange = (
  {
    min = 0,
    max = 100,
    step= 1,
    direction = 'horizontal',
    initialValue = [50],
    inputMiddleware = (value) => { return value },
    outputMiddleWare = (value) => { return value },
    onChange = () => {},
    customTip,
    showTip = false,
    thumbDiameter = 16
  }
) => {


  const [state, setState] = useState(initialValue);
  const [value, setValue] = useState(initialValue.map(v => inputMiddleware(v)))

 useEffect(() => {
   setState(initialValue);
   setValue(initialValue.map(v => inputMiddleware(v)))
 }, [
   initialValue
 ]);

  const dataProcessing = (index, fieldValue) => {
    let _state = (value.length > 1
      ? index === 0 ? [fieldValue, value[1]] : [value[0], fieldValue]
      : [fieldValue]);

    if(parseInt(_state[0]) > parseInt(_state[1])) {
      _state = _state.reverse();
    }

    setValue(_state);
    onChange(_state.map((item) => outputMiddleWare(item)), _state)
  }

  const stylesProcessing = () => {
    const left = (100 / (max - min)) * (value.length > 1 ? value[0] : 0);
    const right = value.length > 1
      ? ((100 / (max - min)) * value[1])
      : normalize0between1(min, max, value[0]) * 100;

    const {start, end} = getThumbOffsetCorrection(min, max, thumbDiameter, value);

    return {
      '--left': value.length > 1 ? `calc(${left}% + ${start})` : '0%',
      '--right': `calc(${right}% + ${end})`
    }
  }

  return (
    <Wrapper>
      <ActionTrack
        onMouseDown={(e) => {
          const {width, left, x} = e.target.getBoundingClientRect()
          const clickX = e.clientX;
          const diff = (clickX - left);
          const percent = 100 / width;
          const offsetInPercent = percent * diff;
          const rangeValue = ((max - min) / 100) * offsetInPercent;
          const valMedium = value[1] ? ((value[1] - value[0]) / 2) + value[0] : max;

          const activeIndex =  rangeValue <= valMedium ? 0 : 1;

          if(value.length > 1) {
            if (activeIndex === 0) {
              setValue([rangeValue, value[1]])
            } else {
              setValue([value[0], rangeValue])
            }
          }else{
            const floor = Math.ceil(rangeValue);
            console.log(
              rangeValue,
              floor,
              (floor % (step)),
              (
                floor - (floor % (step))
              )
            )

            setValue([(floor - (floor % (step)))])
          }
        }}
      ></ActionTrack>
      <FormContainer
        direction={direction}
        style={stylesProcessing()}

      >
        <RangeSelected>
          {
            state.map((_value, index) => {
              return <RangeInput
                key={index}
                type="range"
                value={value[index]}
                aria-valuenow={value[index]}
                onChange={(e) => { dataProcessing(index, e.target.value) }}
                step={step}
                min={min}
                max={max}
              />
            })
          }
        </RangeSelected>
        {
          showTip ? value.map((v, i, self) => {
            return <Bubble direction={direction} key={i} index={i} len={self.length}>
              {
                customTip
                  ? customTip(v, i, self)
                  : <DefaultBubble>
                    {outputMiddleWare(v)}
                  </DefaultBubble>
              }
            </Bubble>
          }) : null
        }
      </FormContainer>
    </Wrapper>
  )
};

const Wrapper = styled.div`
  width: 100%;
  height: 16px;
  position: relative;
  cursor: pointer;
`;

const ActionTrack = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;

const Bubble = styled.div`
  position: absolute;
  left: ${props => props.len > 1 ? (props.index === 0 ? 'var(--left)' : 'var(--right)') : 'var(--right)'};
  transform: ${props => props.direction === 'horizontal' ?  'translateX(-50%) rotate(0)' : 'translateX(-50%) rotate(90deg)'};;
  bottom: 1.5rem;
`;

const DefaultBubble = styled.div`
  padding: 0.2rem 0.4rem;
  background-color: var(--accent-color-primary);
  color: #fff;
  border-radius: 0.2rem;
  font-size: 1rem;
`

const FormContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50deg);
  width: 100%;
  height: var(--int-range-track-height, 0.2rem);
  background-color: var(---int-range-track-color, #aaa);
  touch-action: pan-x;
  display: block;
  transform: ${props => props.direction === 'horizontal' ?  'rotate(0)' : 'rotate(-90deg)'};
`;

const RangeSelected = styled.div`
  width: 100%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  height: 100%;
  &:before {
    content: '';
    position: absolute;
    background-color: var(---int-range-runnable-track-color, var(--accent-color-primary));
    height: 100%;
    width: auto;
    left: var(--left);
    right: var(--right);
    width: calc(var(--right) - var(--left));
  }
  
`;
const RangeInput = styled.input`
  position: absolute;
  width: 100%;
  display: block;
  top: 50%;
  left: 0;
  right: 0;
  pointer-events: none;
  background-clip: content-box;
  transform: translateY(-50%);
  background-color: transparent;
  margin: 0;
  appearance: none;
  outline: none;
  &::-webkit-slider-thumb {
    position: relative;
    appearance: none;
    background-color: var(---int-range-thumb-color, var(--accent-color-primary));
    border: none;
    border-radius: 50%;
    height: 1rem;
    width: 1rem;
    cursor: ew-resize;
    pointer-events: all;
    z-index: 3;
  }
  &:focus::-webkit-slider-thumb {
    background-color: var(---int-range-thumb-color-focused, var(--accent-color-primary-hovered));
  }
  &::-webkit-slider-runnable-track,
  &::-moz-range-track{
    min-inline-size: 0px;
    align-self: center;
    box-sizing: border-box;
    display: block;
    -webkit-user-modify: read-only !important;
    flex: 1 1 0%;
    background: transparent;
  }
  &::-webkit-slider-container {
    background-color: transparent;
  }
`;